import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Homepage } from '../models/homepage';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class HomepageService {
  private http = inject(HttpClient);
  configService = inject(ConfigService);

  getHomepage(): Observable<Homepage> {
    return this.http.get<Homepage>(`${this.configService.getConfiguration().apiHost}/api/homepage`);
  }

  postDataById(hp: Homepage): Observable<Homepage> {
    return this.http.post<Homepage>(`${this.configService.getConfiguration().apiHost}/api/homepage/${hp.id}`, hp);
  }
}
